import Swiper from 'swiper';
import { A11y, Navigation } from 'swiper/modules';
Swiper.use([ A11y, Navigation]);

jQuery(document).ready(function() {
  if (jQuery('.swiper-images').length) {
    new Swiper('.swiper-images', {
      slidesPerView: 1,
      spaceBetween: 16,
      speed: 1000,
      a11y: {
        enabled: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1199: {
          slidesPerView: 4,
        },
        767: {
          slidesPerView: 3,
        },
        450: {
          slidesPerView: 2,
        },
      },
    });
  }
});
